// ==============================
// 파일명 : src/utils/validation/email.js
// 역할 : 이메일 문자열에 대한 형식 검증 함수를 제공해 폼 컴포넌트들이 동일한 기준으로 유효성 검사를 수행하도록 지원
// 수정일 : 2025-10-14
// ==============================

import { USER_EMAIL_REGEX } from "../../constants/users/validation"; // [수정] 이메일 정규식 상수 재사용

export const isEmailFormatValid = (value) => USER_EMAIL_REGEX.test(value); // [수정] 이메일 형식 유효 여부 반환 함수